var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTabArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 24,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.046 13.928a1.5 1.5 0 1 0-2.24 1.995l18.931 20.149a1.5 1.5 0 0 0 2.176.068L44.982 15.99a1.5 1.5 0 1 0-2.112-2.13L24.926 32.894 7.046 13.928z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabArrow);
export default __webpack_public_path__ + "static/media/tab-arrow.5050a9a65b0d963406bf29094cca09b7.svg";
export { ForwardRef as ReactComponent };